// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AudioPlayerPlayList__container-db8f17 {
  --audio-player-list-padding: 8px;
  background-color: var(--base-0);
  border-top: 1px solid var(--base-20);
  border-radius: 16px 16px 0 0;
  max-height: 0;
  padding-bottom: var(--audio-player-height);
  padding-top: var(--audio-player-list-padding);
  position: absolute;
  bottom: calc(var(--audio-player-list-padding) * -2);
  left: 0;
  width: 100%;
  transition: max-height 0.3s ease;
  will-change: max-height;
}

.AudioPlayerPlayList__container-db8f17.AudioPlayerPlayList__opened-a64a8f {
  box-shadow: 0 8px 9px 0 rgba(0, 0, 0, 0.1);
  padding-bottom: calc(var(--audio-player-height) + var(--audio-player-list-padding));
}

.AudioPlayerPlayList__list-d5ad08 {
  overflow: auto;
  max-height: 216px;
}

.AudioPlayerPlayList__item-d2d697 {
  display: flex;
  gap: 12px;
  padding-top: 4px;
  padding-bottom: 4px;
  padding-inline-start: 12px;
  padding-inline-end: 16px;
}

.AudioPlayerPlayList__icon-bf696a {
  cursor: pointer;
}

.AudioPlayerPlayList__info-cab38f {
  overflow: hidden;
}

.AudioPlayerPlayList__title-c72afd {
  cursor: pointer;
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
  color: var(--base-110);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/Media/AudioPlayer/AudioPlayerUI/AudioPlayerPlayList/AudioPlayerPlayList.styles.m.css"],"names":[],"mappings":"AAAA;EACE,gCAAA;EAEA,+BAAA;EACA,oCAAA;EACA,4BAAA;EACA,aAAA;EACA,0CAAA;EACA,6CAAA;EACA,kBAAA;EACA,mDAAA;EACA,OAAA;EACA,WAAA;EAEA,gCAAA;EACA,uBAAA;AADF;;AAIA;EACE,0CAAA;EACA,mFAAA;AADF;;AAIA;EACE,cAAA;EACA,iBAAA;AADF;;AAIA;EACE,aAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;EACA,0BAAA;EACA,wBAAA;AADF;;AAIA;EACE,eAAA;AADF;;AAIA;EACE,gBAAA;AADF;;AAIA;EACE,eAAA;EACA,wBAAA;EACA,0CAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AADF","sourcesContent":[".container {\n  --audio-player-list-padding: 8px;\n\n  background-color: var(--base-0);\n  border-top: 1px solid var(--base-20);\n  border-radius: 16px 16px 0 0;\n  max-height: 0;\n  padding-bottom: var(--audio-player-height);\n  padding-top: var(--audio-player-list-padding);\n  position: absolute;\n  bottom: calc(var(--audio-player-list-padding) * -2);\n  left: 0;\n  width: 100%;\n\n  transition: max-height 0.3s ease;\n  will-change: max-height;\n}\n\n.container.opened {\n  box-shadow: 0 8px 9px 0 rgba(0, 0, 0, 0.1);\n  padding-bottom: calc(var(--audio-player-height) + var(--audio-player-list-padding));\n}\n\n.list {\n  overflow: auto;\n  max-height: 216px;\n}\n\n.item {\n  display: flex;\n  gap: 12px;\n  padding-top: 4px;\n  padding-bottom: 4px;\n  padding-inline-start: 12px;\n  padding-inline-end: 16px;\n}\n\n.icon {\n  cursor: pointer;\n}\n\n.info {\n  overflow: hidden;\n}\n\n.title {\n  cursor: pointer;\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n  color: var(--base-110);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AudioPlayerPlayList__container-db8f17`,
	"opened": `AudioPlayerPlayList__opened-a64a8f`,
	"list": `AudioPlayerPlayList__list-d5ad08`,
	"item": `AudioPlayerPlayList__item-d2d697`,
	"icon": `AudioPlayerPlayList__icon-bf696a`,
	"info": `AudioPlayerPlayList__info-cab38f`,
	"title": `AudioPlayerPlayList__title-c72afd`
};
module.exports = ___CSS_LOADER_EXPORT___;
